import { computed } from "vue";
import { useRootStore } from "@/store/root";
import { resolveAccessibilityWidgetPlacement } from "@/utils/accessibilityWidgetPlacement";

export function useAccessibilityWidgetPlacement() {
  const rootStore = useRootStore();

  const placement = computed(() =>
    resolveAccessibilityWidgetPlacement({
      hasHeader: rootStore.hasHeader,
      hasFooter: rootStore.hasFooter,
      hasBookingFooter: rootStore.hasBookingFooter,
      theme: rootStore.theme,
    }),
  );

  const showInHeader = computed(() => placement.value === "header");
  const showInFooter = computed(() => placement.value === "footer");
  const showInBookingFooter = computed(
    () => placement.value === "bookingFooter",
  );
  const showInPageEnd = computed(() => placement.value === "pageEnd");
  /** @deprecated Prefer `showInPageEnd` — Ansicht is no longer in the filter sidebar. */
  const showInSidebar = showInPageEnd;

  return {
    placement,
    showInHeader,
    showInFooter,
    showInBookingFooter,
    showInPageEnd,
    showInSidebar,
  };
}
